// extracted by mini-css-extract-plugin
module.exports = {"typesDropdown":"src-components-calendar-TypesDropdown-styles__typesDropdown","trigger":"src-components-calendar-TypesDropdown-styles__trigger"};